module.exports = __webpack_public_path__ + "img/history-img.4dbf6023.png";